/**
 * 
 */

(function(window, undefined) {
	"use strict";
	var Route = function($stateProvider, $urlRouterProvider) {
		var onEnter = [ 'CblMessageSrvc', function(messaggiSrvc) {
			messaggiSrvc.reset();
		} ];

		$stateProvider
				.state(
					"creas-ricerca-pratiche",
					{
						url : "/creas-ricerca-pratiche?intestazione&stato&dataDa&dataA",
						template : "<creas-ricerca-pratiche " +
								"class=\"wrapper\"></creas-ricerca-pratiche>",
						onEnter : onEnter,
						ncyBreadcrumb : {
							label : "Ricerca Pratiche",
							parent : "home"
						},
						params: {
							intestazione : {
								value: '',
								squash: true
							},
							stato : {
								value: '',
								squash: true
							},
							dataDa : {
								value: null,
								squash: true
							},
							dataA : {
								value: null,
								squash: true
							}
						}
					})
				.state(
					"creas-ricerca-cliente",
					{
						url : "/creas-ricerca-cliente",
						template : "<creas-ricerca-cliente " +
								"class=\"wrapper\"></creas-ricerca-cliente>",
						onEnter : onEnter,
						ncyBreadcrumb : {
							label : "Ricerca Cliente",
							parent : "creas-ricerca-pratiche"
						}
					})
				.state(
					"creas-nuova-pratica",
					{
						url : "/creas-nuova-pratica/:ndg/:codProdotto",
						template : "<creas-dettaglio-pratica " +
								"class=\"wrapper\"></creas-dettaglio-pratica>",
						onEnter : onEnter,
						ncyBreadcrumb : {
							label : "Nuova Pratica",
							parent : "home"
						}
					})
				.state(
					"creas-dettaglio-pratica",
					{
							url : "/creas-dettaglio-pratica/:ndg/:idPratica",
						template : "<creas-dettaglio-pratica " +
								"class=\"wrapper\"></creas-dettaglio-pratica>",
						onEnter : onEnter,
						ncyBreadcrumb : {
							label : "Dettaglio Pratica",
							parent : "home"
						}
					})
				.state(
					"creas-dettaglio-affidamento",
					{
						url : "/creas-dettaglio-affidamento/:ndg",
						template : "<creas-affidamento class=\"wrapper\"></creas-affidamento>",
						onEnter : onEnter,
						parentState: 'schedaCliente',
						ncyBreadcrumb : {
							label : "Dettaglio Affidamento",
							parent : "schedaCliente"
						}
					});
	};

	Route.$inject = [ "$stateProvider", "$urlRouterProvider" ];

	angular.module("cbl.insuranceloanpmi.mf").config(Route);
}(window));



//////////////////
// WEBPACK FOOTER
// ./app/app.route.js
// module id = 42
// module chunks = 1